<template>
  <div>
    <!-- edit shift modal -->
    <modal
      name="edit-saturday-shift-modal"
      :adaptive="true"
      :reset="true"
      height="auto"
      :resizable="true"
      :scrollable="true"
      :focusTrap="true"
      draggable=".window-header"
    >
      <edit-saturday-shift
        :selectedShift="selectedShift"
        :isSaveAndProceedButtonVisible="false"
        title="Uredi radno vrijeme"
        @saveAndCloseClicked="editShift"
      />
    </modal>

    <!-- add shift modal -->
    <modal
      name="add-saturday-shift-modal"
      :adaptive="true"
      :reset="true"
      height="auto"
      :resizable="true"
      :scrollable="true"
      :focusTrap="true"
      draggable=".window-header"
    >
      <edit-saturday-shift
        :selectedShift="selectedShift"
        :isSaveAndProceedButtonVisible="true"
        title="Dodaj radno vrijeme"
        @saveAndCloseClicked="addShift"
        @saveAndProceedClicked="addShiftAndContinue"
      />
    </modal>

    <!-- delete shift modal -->
    <modal
      name="delete-saturday-shift-modal"
      :adaptive="true"
      :reset="true"
      :focusTrap="true"
      draggable=".window-header"
    >
      <delete-item
        message="Da li zaista žekite da obrišete radno vrijeme?"
        title="Obriši radno vrijeme"
        :selectedItem="selectedShift"
        @deleteButtonClicked="deleteShift"
      />
    </modal>

    <!-- Title -->
    <h1 class="title has-text-success">Radne subote</h1>
    <h2 class="subtitle">Administracija radnih subota u preduzeću</h2>

    <!-- Table -->
    <vue-good-table
      :columns="columns"
      :rows="rows"
      :search-options="{
        enabled: true,
        searchFn: searchFunc,
        placeholder: 'Pretraži...',
      }"
    >
      <template slot="table-row" slot-scope="props">
        <span v-if="props.column.field == 'before'">
          <!-- edit icon -->
          <span class="icon has-text-info">
            <i
              class="fas fa-edit"
              v-show="props.row.isnew === false"
              @click="editRow(props.row)"
            >
              <font-awesome-icon icon="edit" />
            </i>
          </span>
          <!-- delete icon -->
          <span class="icon has-text-danger">
            <i
              class="fas fa-trash-alt"
              v-show="props.row.isnew === false"
              @click="deleteRow(props.row)"
            >
              <font-awesome-icon icon="trash-alt" />
            </i>
          </span>
          <!-- add new row button -->
          <button
            class="button is-info is-size-7"
            v-show="props.row.isnew === true"
            @click="addRow(props.row)"
          >
            Dodaj
          </button>
        </span>
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>
    </vue-good-table>
  </div>
</template>

<script>
import UserService from "../../services/user.service";
import EditSaturdayShift from "../parts/EditSaturdayShift.vue";
import DeleteItem from "../parts/DeleteItem.vue";
import "vue-good-table/dist/vue-good-table.css";
import "vue-select/dist/vue-select.css";
import { VueGoodTable } from "vue-good-table";
import {
  SaturdayShiftBack,
  SaturdayShiftFront,
} from "../../models/satudayshift";

export default {
  components: {
    VueGoodTable,
    EditSaturdayShift,
    DeleteItem,
  },
  name: "SaturdayShifts",
  data() {
    return {
      selectedShift: {},
      shifts: [],
      columns: [
        {
          label: "R.Br.",
          field: "saturdayshiftId",
          type: "number",
          sortable: false,
        },
        {
          label: "Ime",
          field: "note",
          sortable: false,
        },
        {
          label: "Opis",
          field: "description",
          sortable: false,
        },
        // {
        //   label: "Fixed",
        //   field: "isStartTimeFixed",
        //   type: "boolean",
        //   sortable: false,
        // },
        // {
        //   label: "Status",
        //   field: "status",
        //   type: "boolean",
        //   sortable: false,
        // },
        // {
        //   label: "Sektor",
        //   field: "department.name",
        //   sortable: false,
        // },
        // {
        //   label: "Grupa",
        //   field: "accessGroupId",
        //   sortable: false,
        // },
        {
          label: "Akcije",
          field: "before",
          sortable: false,
        },
      ],
      rows: [],
      errorMessage: "",
    };
  },
  mounted() {
    this.getSaturdayShifts();
  },
  methods: {
    collectErrorMessage(error) {
      let msg =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();

      return msg;
    },
    resetUi() {
      this.shifts = [];
      this.rows = [];
    },
    searchFunc(row, col, cellValue, searchTerm) {
      if (typeof cellValue === "string" || cellValue instanceof String) {
        return cellValue.toLowerCase().includes(searchTerm.toLowerCase());
      } else if (cellValue == null) {
        return true;
      }
    },
    resetSelectedShift() {
      this.selectedShift = {};
    },
    getSaturdayShifts() {
      UserService.GetSaturdayShifts().then(
        (response) => {
          // reset ui
          this.resetUi();

          console.log(response);

          // get new data
          // populate rows
          response.data.forEach((element) => {
            let shf = new SaturdayShiftFront(element);
            this.rows.push(shf);
          });
          // response.data.forEach((element) => {
          //   // populate shifts
          //   this.shifts.push({
          //     name: element.name,
          //     id: element.shiftId,
          //   });

          // });

          // add "add" row
          this.rows.push(
            new SaturdayShiftFront({
              isnew: true,
            })
          );
          console.log(this.rows);
        },
        (error) => {
          this.collectErrorMessage(error);
        }
      );
    },
    editRow(shft) {
      this.selectedShift = new SaturdayShiftFront(shft);
      this.$modal.show("edit-saturday-shift-modal");
    },
    deleteRow(shft) {
      this.selectedShift = shft;
      this.$modal.show("delete-saturday-shift-modal");
    },
    addRow(shft) {
      this.selectedShift = shft;
      this.$modal.show("add-saturday-shift-modal");
    },
    editShift(shift) {
      let shiftToEdit = new SaturdayShiftBack(shift);

      UserService.putShift(shiftToEdit).then(
        () => {
          // reload ui
          this.resetUi();

          this.getShifts();
        },
        (error) => {
          this.errorMessage = this.collectErrorMessage(error);
        }
      );

      this.$modal.hide("edit-saturday-shift-modal");
    },
    deleteShift() {
      let shiftToDelete = new SaturdayShiftBack(this.selectedShift);

      UserService.deleteShift(shiftToDelete).then(
        () => {
          // reload depts
          this.resetUi();

          this.getShifts();
        },
        (error) => {
          this.errorMessage = this.collectErrorMessage(error);
        }
      );
      this.$modal.hide("delete-saturday-shift-modal");
    },
    addShiftAndContinue(saturdayShift) {
      // create new employer
      let newSaturdayShift = new SaturdayShiftBack(saturdayShift);

      // upload
      // call axios
      UserService.postShift(newSaturdayShift).then(() => {
        // reset ui
        this.resetUi();

        this.GetSaturdayShifts();
      });
    },
    addShift(saturdayShift) {
      // create new employer
      let newSaturdayShift = new SaturdayShiftBack(saturdayShift);

      // upload
      // call axios
      UserService.postSaturdayShift(newSaturdayShift).then(() => {
        // reset ui
        this.resetUi();

        this.GetSaturdayShifts();

        this.$modal.hide("add-saturday-shift-modal");
      });
    },
  },
};
</script>
